/* eslint-disable */
/*
 * Modified copy of EXT:t3oodle's t3oodle.js file
 * Differences have been wrapped with comments.
 */
'use strict';

var tx_t3oodle = {
    vars: {
        path: '',
        newOptionIndex: 2,
    },
    loadScript: function (name, callback) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        if (callback) {
            script.onload = callback;
        }
        script.src = this.vars.path + 'JavaScript/t3oodle/' + name;
        document.getElementsByTagName('head')[0].appendChild(script);
    },
    loadScriptBySelector: function (script, selector, callback) {
        var items = document.querySelectorAll(selector);
        if (items.length > 0) {
            this.loadScript(script + '.js', callback || function () {
                tx_t3oodle[script](selector);
            });
        }
    },
    init: function (scriptNodeOrPath) {
        // This part has been adjusted (begin)
        var t3oodle = document.querySelector('.tx-t3oodle');
        if (t3oodle === null) {
            // No t3oodle element found, skip initalization. That indicates a page without a t3oodlesurvey.
            return;
        }
        this.vars.path = t3oodle.dataset.t3oodlepath;
        // This part has been adjusted (end)

        if (document.getElementById('t3oodleLastOptionIndex')) {
            this.vars.newOptionIndex = document.getElementById('t3oodleLastOptionIndex').value;
        }

        // Init required scripts
        this.loadScriptBySelector('confirmation', '*[data-confirm]');
        this.loadScriptBySelector('remember', '*[data-remember]');
        this.loadScriptBySelector('conditional-inputs', 'input[data-bind-disable]');
        this.loadScriptBySelector('force-checked', 'input[data-force-checked]');
        this.loadScriptBySelector('voting-box', '.t3oodle-voting-checkbox');
        this.loadScriptBySelector('toggle-display', '*[data-toggle-display]');
        this.loadScriptBySelector('utils-options', '.t3oodle-new-poll-option, .t3oodle-options-per-day', function () {
            tx_t3oodle.loadScriptBySelector('options-simple', '.t3oodle-new-poll-option');
            tx_t3oodle.loadScriptBySelector('options-schedule', '.t3oodle-options-per-day');
        });
        this.loadScriptBySelector('date-picker', '*[data-date-picker]');
        this.loadScriptBySelector('sortable-list', '*[data-sortable-list]');
    },
};

// This part has been adjusted (begin)
window.tx_t3oodle = tx_t3oodle;
window.tx_t3oodle.init('');
// This part has been adjusted (end)
